// TournamentAccess.js
import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid2'
import { styled } from '@mui/material/styles'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useNavigate } from 'react-router-dom'
import { getData } from '../api/indexedDBHandler'
import { isOnline, clearTable } from '../api/indexedDBHandler'
import axios from 'axios'
import PersonAddAlt1SharpIcon from '@mui/icons-material/PersonAddAlt1Sharp'
import CardAccess from './Users/CardAccess'
import CardSearchAccess from './Users/CardSearchAccess'
import { updateData, addRequestsData } from '../api/indexedDBHandler'

import Modal from '@mui/material/Modal'
import CircularProgress from '@mui/material/CircularProgress'
import TextField from '@mui/material/TextField'

function TournamentAccess() {
  const { id } = useParams() // Извлечение параметра из URL
  const [tournament, setTournament] = useState(null)
  const navigate = useNavigate()
  const [accessList, setSccessList] = useState(null)
  const [loading, setLoading] = useState(false)

  const [organizer, setOrganizer] = useState(null) // Организатор
  const [chiefJudge, setChiefJudge] = useState(null) // Главный судья
  const [chiefSecretary, setChiefSecretary] = useState(null) // Главный секретарь
  const [judgeSecretary, setJudgeSecretary] = useState(null) // Судья - секретарь
  const [judge, setJudge] = useState(null) // Судья
  const [disabledjudge, setDisabledjudge] = useState(false)
  const [disabledSecretary, setDisabledSecretary] = useState(false)
  const [idvalue, setidvalue] = useState(null)
  const [codevalue, setcodevalue] = useState(null)
  const [openModalNewAccess, setModalNewAccess] = React.useState(false)
  const [issearch, setissearch] = useState(false)
  const [roles, setroles] = useState('')

  // const filteredTeams = teams.filter((e) => e.team.status == alignment)

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))

  const handleCloseModalNewAccess = () => {
    setModalNewAccess(false)
  }

  useEffect(() => {
    const getTournament = async () => {
      if (isOnline()) {
        const results = await getData('tournaments', 'id', id)
        if (results.length > 0) {
          const { value } = results[0]
          setTournament(value)
        }
        const resultsuser = await getData('user', 'created', true)
        const { key, value } = resultsuser[0]
        const user = {
          id: id,
          token: value.token,
          phone: value.phone,
        }
        const response = await axios.post(
          'https://admin-protocarp.ru/php/access/getAccessIdTournament.php',
          {
            ...user,
          }
        )
        if (response.data.success) {
          setLoading(false)
          const administratorArray = Object.values(
            response.data.administrator.administrator
          )
          const filteredorganizer = administratorArray.filter(
            (e) => e.role == 'Организатор'
          )
          setOrganizer(filteredorganizer)
          const filteredchiefJudge = administratorArray.filter(
            (e) => e.role == 'Главный судья'
          )
          setChiefJudge(filteredchiefJudge)

          const filteredchiefSecretary = administratorArray.filter(
            (e) => e.role == 'Главный секретарь'
          )
          setChiefSecretary(filteredchiefSecretary)
          const filteredjudgeSecretary = administratorArray.filter(
            (e) => e.role == 'Судья - секретарь'
          )
          setJudgeSecretary(filteredjudgeSecretary)
          const filteredjudge = administratorArray.filter(
            (e) => e.role == 'Судья'
          )
          setJudge(filteredjudge)

          setSccessList(administratorArray)
        } else if (response.data.error_code == 404) {
          setLoading(false)
          setSccessList([])
          await clearTable('user')
        } else {
          setLoading(false)
        }
      } else alert('Отсутствует соединение с интернетом. ')
    }
    getTournament()
  }, [id])

  useEffect(() => {
    if (chiefJudge)
      if (chiefJudge.length > 0) {
        setDisabledjudge(true)
      }
  }, [chiefJudge])
  useEffect(() => {
    if (chiefSecretary)
      if (chiefSecretary.length > 0) {
        setDisabledSecretary(true)
      }
  }, [chiefSecretary])
  useEffect(() => {
    if (!tournament) return
    const regexWeighing = /(Главный судья|Организатор)/i
    if (!regexWeighing.test(tournament.roles)) {
      navigate('/')
    }
  }, [tournament])

  const dellUser = async (e) => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm(
      'Удалить ' + e?.surname + ' ' + e?.name + ' из списка?   '
    )
    if (result) {
      if (e.role == 'Организатор') {
        const filterorganizer = organizer.filter(
          (item) => item.login != e.login
        )
        setOrganizer(filterorganizer)
      } else if (e.role == 'Главный судья') {
        const filterchiefJudge = chiefJudge.filter(
          (item) => item.login != e.login
        )
        setChiefJudge(filterchiefJudge)
      } else if (e.role == 'Главный секретарь') {
        const filterchiefSecretary = chiefSecretary.filter(
          (item) => item.login != e.login
        )
        setChiefSecretary(filterchiefSecretary)
      } else if (e.role == 'Судья - секретарь') {
        const filterjudgeSecretary = judgeSecretary.filter(
          (item) => item.login != e.login
        )
        setJudgeSecretary(filterjudgeSecretary)
      } else if (e.role == 'Судья') {
        const filterjudge = judge.filter((item) => item.login != e.login)
        setJudge(filterjudge)
      }
      e.id = id

      const requestKey = `${e.id}_dellUser_${new Date().getTime()}`
      // (e.timestamp = new Date().getTime())
      try {
        await addRequestsData('requests', {
          url: 'access/dellUser.php',
          ...e,
          requestKey,
        })
      } catch (error) {}
    }
  }

  const saveUser = async (e) => {
    if (roles == 'Организатор') {
      setOrganizer([...organizer, e])
    } else if (roles == 'Главный судья') {
      setChiefJudge([...chiefJudge, e])
    } else if (roles == 'Главный секретарь') {
      setChiefSecretary([...chiefSecretary, e])
    } else if (roles == 'Судья - секретарь') {
      setJudgeSecretary([...judgeSecretary, e])
    } else if (roles == 'Судья') {
      setJudge([...judge, e])
    }
    e.id = id
    e.requestKey = `${e.id}_addNeUser_${new Date().getTime()}`

    //   const requestKey = `${e.id}_dellUser_${new Date().getTime()}`
    //  requestKey: `${token}_${phone}_${new Date().getTime()}`,

    try {
      await addRequestsData('requests', {
        url: 'access/addNeUser.php',
        ...e,
      })
    } catch (error) {}
    setModalNewAccess(false)
  }

  const viewSearchUserModal = async (type) => {
    setroles(type)
    setidvalue('')
    setcodevalue('')
    setissearch(false)
    setModalNewAccess(true)
  }

  const buttonEditType = async () => {
    setissearch(false)
    setLoading(true)
    const results = await getData('user', 'created', true)
    const { key, value } = results[0]
    const user = {
      id: id,
      token: value.token,
      phone: value.phone,
      idvalue: idvalue,
      codevalue: codevalue,
      role: roles,
    }
    const response = await axios.post(
      'https://admin-protocarp.ru/php/access/searchUser.php',
      {
        ...user,
      }
    )
    if (response.data.success) {
      setissearch(
        <CardSearchAccess
          props={response.data.administrator.administrator[0]}
          func={saveUser}
        />
      )
      setLoading(false)
    } else if (response.data.error_code == 404) {
      setLoading(false)
      await clearTable('user')
    } else {
      setLoading(false)
    }
  }
  if (accessList)
    return (
      <Container sx={{ mb: 15 }}>
        <div role="presentation" style={{ textAlign: 'left', width: '100%' }}>
          <Breadcrumbs maxItems={2} aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/tournaments-list">
              Турниры
            </Link>
            <Link underline="hover" color="inherit" href={'/tournaments/' + id}>
              Редактирование
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Доступы</Typography>
          </Breadcrumbs>
        </div>
        <Typography variant="h6" gutterBottom color="black" sx={{ mt: 2 }}>
          {tournament.tournament_name}
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          Изменения в этом разделе требуют наличия соединения с интернетом.
        </Alert>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: 'space-between',
                    marginBottom: '10px',
                  }}
                >
                  <Typography variant="body2" gutterBottom>
                    Организаторы
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => viewSearchUserModal('Организатор')}
                    startIcon={<PersonAddAlt1SharpIcon />}
                  >
                    Добавить
                  </Button>
                </Stack>
                {organizer.map((item, index) => (
                  <CardAccess key={index} props={item} func={dellUser} />
                ))}
                <Typography
                  variant="caption"
                  style={{ color: 'gray' }}
                  gutterBottom
                >
                  Организатор может: изменять настройки турнира, добавлять
                  других судей и секретарей, добавлять спонсоров, работать с
                  документацией, подтверждать и добавлять команды, настраивать
                  выгрузку в соцсети
                </Typography>
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: 'space-between',
                    marginBottom: '10px',
                  }}
                >
                  <Typography variant="body2" gutterBottom>
                    Главный судья
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={disabledjudge}
                    onClick={(e) => viewSearchUserModal('Главный судья')}
                    startIcon={<PersonAddAlt1SharpIcon />}
                  >
                    Добавить
                  </Button>
                </Stack>
                {chiefJudge.length == 0 && (
                  <Typography
                    variant="body2"
                    style={{ color: 'red' }}
                    gutterBottom
                  >
                    Нет добавленных главных судей
                  </Typography>
                )}
                {chiefJudge.map((item, index) => (
                  <CardAccess key={index} props={item} func={dellUser} />
                ))}
                <Typography
                  variant="caption"
                  style={{ color: 'gray' }}
                  gutterBottom
                >
                  Главный судья может: изменять настройки турнира, добавлять
                  других судей и секретарей, проводить жеребьёвку и взвешивание
                  команд, добавлять спонсоров, работать с документацией,
                  подтверждать и добавлять команды
                </Typography>
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: 'space-between',
                    marginBottom: '10px',
                  }}
                >
                  <Typography variant="body2" gutterBottom>
                    Главный секретарь
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={disabledSecretary}
                    onClick={(e) => viewSearchUserModal('Главный секретарь')}
                    startIcon={<PersonAddAlt1SharpIcon />}
                  >
                    Добавить
                  </Button>
                </Stack>
                {chiefSecretary.length == 0 && (
                  <Typography
                    variant="body2"
                    style={{ color: 'red' }}
                    gutterBottom
                  >
                    Нет добавленных главных секретарей
                  </Typography>
                )}
                {chiefSecretary.map((item, index) => (
                  <CardAccess key={index} props={item} func={dellUser} />
                ))}
                <Typography
                  variant="caption"
                  style={{ color: 'gray' }}
                  gutterBottom
                >
                  Главный секретарь может: проводить жеребьёвку, добавлять
                  спонсоров, работать с документацией, подтверждать и добавлять
                  команды
                </Typography>
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: 'space-between',
                    marginBottom: '10px',
                  }}
                >
                  <Typography variant="body2" gutterBottom>
                    Судьи
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => viewSearchUserModal('Судья')}
                    startIcon={<PersonAddAlt1SharpIcon />}
                  >
                    Добавить
                  </Button>
                </Stack>
                {judge.length == 0 && (
                  <Typography
                    variant="body2"
                    style={{ color: 'red' }}
                    gutterBottom
                  >
                    Нет добавленных судей
                  </Typography>
                )}
                {judge.map((item, index) => (
                  <CardAccess key={index} props={item} func={dellUser} />
                ))}
                <Typography
                  variant="caption"
                  style={{ color: 'gray' }}
                  gutterBottom
                >
                  Судья может: проводить жеребьёвку, проводить взвешивание
                  команд, добавлять спонсоров
                </Typography>
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: 'space-between',
                    marginBottom: '10px',
                  }}
                >
                  <Typography variant="body2" gutterBottom>
                    Судьи - секретари
                  </Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => viewSearchUserModal('Судья - секретарь')}
                    startIcon={<PersonAddAlt1SharpIcon />}
                  >
                    Добавить
                  </Button>
                </Stack>
                {judgeSecretary.length == 0 && (
                  <Typography
                    variant="body2"
                    style={{ color: 'red' }}
                    gutterBottom
                  >
                    Нет добавленных судей - секретарей
                  </Typography>
                )}
                {judgeSecretary.map((item, index) => (
                  <CardAccess key={index} props={item} func={dellUser} />
                ))}
                <Typography
                  variant="caption"
                  style={{ color: 'gray' }}
                  gutterBottom
                >
                  Судья-секретарь может: проводить жеребьёвку, добавлять
                  спонсоров, работать с документацией, подтверждать и добавлять
                  команды
                </Typography>
              </Item>
            </Grid>
          </Grid>
        </Box>
        <Modal
          open={openModalNewAccess}
          onClose={handleCloseModalNewAccess}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography variant="h6">Предоставить доступ: {roles}</Typography>
            <Typography
              variant="caption"
              gutterBottom
              sx={{ display: 'block' }}
            >
              Для поиска пользователя введите его ID и CODE. Посмотреть их можно
              в главном меню
            </Typography>

            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '20px',
                paddingTop: '20px',
              }}
            >
              <div>
                <TextField
                  id="outlined-basic"
                  label="ID"
                  variant="outlined"
                  type="number"
                  value={idvalue}
                  onChange={(e) => setidvalue(e.target.value)}
                  fullWidth
                />
              </div>
              <div>
                <TextField
                  id="outlined-basic"
                  label="CODE"
                  variant="outlined"
                  type="number"
                  value={codevalue}
                  onChange={(e) => setcodevalue(e.target.value)}
                  fullWidth
                />
              </div>
            </Stack>
            <Box mt={1} display="flex" justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={buttonEditType}
                disabled={loading}
                startIcon={loading && <CircularProgress size={20} />}
              >
                {loading ? 'Загрузка...' : 'Найти'}
              </Button>
            </Box>
            {issearch ? issearch : ''}
          </Box>
        </Modal>
      </Container>
    )
}

export default TournamentAccess
